export const addUniqueValueToArray = ({ array, value, index }) => {
  let currentIndex = array.indexOf(value)

  if (currentIndex === index) return array

  let uniqueArray = array.filter(_value => _value !== value)

  if (!isNaN(index)) {
    uniqueArray.splice(index, 0, value)
  } else {
    uniqueArray.push(value)
  }

  return uniqueArray
}

export const sortArrayWithPositions = (idArray, positionsById) => {
  let allPositions = { ...positionsById }
  idArray.forEach((id, index) => { if (typeof positionsById[id] === 'undefined') allPositions[id] = index })
  let sortedArray = [ ...idArray ]
  sortedArray.sort((a, b) => allPositions[a] - allPositions[b])
  return sortedArray
}

export const calculatePositions = ({ array, id, position }) => {
  let positions = [{
    id,
    position
  }]

  let currentPosition = null
  const current = array.find(item => item.id === id)
  if (current && typeof current.position !== 'undefined') {
    currentPosition = current.position
  }

  for (let i = 0, length = array.length; i < length; i++) {
    const item = array[i]

    if (item.id === id) {
      continue
    }

    if (
      currentPosition === null
    ) {
      if (
        item.position >= position
      ) {
        positions.push({
          id: item.id,
          position: item.position + 1
        })
      }
    } else {
      if (
        item.position > currentPosition &&
        item.position <= position
      ) {
        positions.push({
          id: item.id,
          position: item.position - 1
        })
      } else if (
        item.position < currentPosition &&
        item.position >= position
      ) {
        positions.push({
          id: item.id,
          position: item.position + 1
        })
      }
    }
  }

  return positions
}
